import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Event from "../../components/home/Event";
import Items from "../../components/home/Items";
import Partners from "../../components/home/Partners";
import Service from "../../components/home/Service";
import Test from "../../components/home/Test";
import Contact from "../../components/home/Contact";

export type Category = {
  id: number;
  name: string;
};

export type Products = {
  id: number;
  src: string;
  originName: string;
  savedName: string;
  title: string;
  categoryId: number;
  created: string;
  updated: string;
  orderId: number;
};

const Home = () => {
  const [blog, setBlog] = useState<any[]>([]);
  const [category, setCategory] = useState<Category[] | null>(null);
  const [data, setData] = useState<Products[] | null>(null);

  useEffect(() => {
    axios.get("/api/blog").then((res) => {
      if (res.data.code === "0000") setBlog(res.data.data);
      else
        Swal.fire({
          title: "너무 많은 요청이 들어왔습니다. 다시 시도해주세요.",
          icon: "error",
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`/api/category`)
      .then((res) => {
        if (res.data.code === "0000") {
          setCategory(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, []);

  useEffect(() => {
    axios
      .get(`/api/product/1`)
      .then((res) => {
        if (res.data.code === "0000") {
          setData(res.data.data);
        }
      })
      .catch((e) => console.error(e));
  }, []);
  return (
    <>
      <Banner />
      <Event />
      <About />
      <Items category={category} data={data} />
      <Service />
      <Blog data={blog} />
      <Test />
      <Contact />
      <Partners />
    </>
  );
};

export default Home;
